import {useEffect, useRef} from "react";

import { isHotKey } from "../utils/dom";

export const useHotKey = (hotkeyData, action) => {
  const actionRef = useRef();
  actionRef.current = action;
  useEffect(() => {
    const onDocumentKeyDown = (e) => {
      if (isHotKey(e, hotkeyData)) {
        actionRef.current(e);
        e.preventDefault();
      }
    };

    document.addEventListener("keydown", onDocumentKeyDown);
    return () => {
      document.removeEventListener("keydown", onDocumentKeyDown);
    };
  }, [hotkeyData]);
};
